module.exports = __webpack_public_path__ + "static/media/rat.411fecd6.png";